module.exports = __webpack_public_path__ + "img/logo-lg.9753c9a0.svg";